import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { urlPublicS3 } from '../../helpers';

function ApprovalFiles({ files, label }) {
  return (
    <div>
      <p className="second title-2">{label}</p>
      <div className="list_items_file">
        {files && files.length > 0 ? (
          <ul>
            {files.map((file, i) => (
              <li key={i}>
                <a
                  className="a-vehicle"
                  href={`${urlPublicS3()}/${file.download_link}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Ver archivo {i + 1}
                </a>
              </li>
            ))}
          </ul>
        ) : (
          <p className="txt">-</p>
        )}
      </div>
    </div>
  );
}

function AdditionalApprovalsHistory({ approvals, serviceId }) {
  const { t } = useTranslation('maintenance');

  const visibleApprovals = (approvals || []).filter((a) => a.status !== 'denied');

  if (visibleApprovals.length === 0) return null;

  return (
    <Row>
      <hr style={{ margin: '8px 0' }} />
      <Col xs={12} className="col-collapse">
        <p className="second title-2">{t('additional-approvals-history')}</p>
        {visibleApprovals.map((approval, idx) => (
          <div key={approval.id}>
            {idx > 0 && <hr style={{ margin: '6px 0', borderStyle: 'dashed' }} />}
            <p className="second" style={{ marginBottom: '4px' }}>#{approval.instance_number}</p>
            <Row>
              <Col xs={12} md={6} className="col-collapse">
                <ApprovalFiles files={approval.quotation} label={t('quotation-label')} />
              </Col>
              <Col xs={12} md={6} className="col-collapse">
                <ApprovalFiles files={approval.img_quotation} label={t('images-label')} />
              </Col>
            </Row>
          </div>
        ))}
      </Col>
    </Row>
  );
}

AdditionalApprovalsHistory.propTypes = {
  approvals: PropTypes.array,
  serviceId: PropTypes.number.isRequired,
};

AdditionalApprovalsHistory.defaultProps = {
  approvals: [],
};

export default AdditionalApprovalsHistory;
